<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="4" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                    <van-col span="16">
                        <div class="banner-title">{{ $t('newYearHistory.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="month-box" v-for="item in menu">
                <div class="week-box">
                    <div class="week"
                         @click="toYearDesc(item.year)"
                    >
                        {{item.year}}
                        <img class="to-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/06to.svg`)">
                    </div>
                </div>
            </div>
            <div class="no-tag">{{ $t('newMonthHistory.no') }}</div>
        </div>
    </div>
</template>


<script>
    import {GetMonth} from '@/utils/dateUtils'
    import {getQueryVariable} from '@/utils/comment'
    export default {

        data() {
            return {
                theme: 'light',
                menu: [],
            }
        },
        mounted() {
            this.theme = this.$route.query.theme ? this.$route.query.theme : 'light';
            this.initDate();
        },
        methods: {
            back() {
                this.$router.push({
                    name: 'newSportList',
                    query: {
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            },
            initDate() {
                let startYear = 2023;
                let endYear = new Date().getFullYear() - 1;
                let yearCount = endYear - startYear;
                let menu = [];
                for (let i = 0; i <= yearCount; i++) {
                    menu.push({
                        year: startYear + i,
                    })
                }
                this.menu = menu.reverse();
            },
            toYearDesc(year) {
                this.$router.push({
                    name: 'openYear',
                    query: {
                        year,
                        lang: this.$i18n.locale,
                        theme: this.theme
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .month-box {
        margin-top: 20px;
    }

    .month-text {
        font-size: 14px;
        margin-left: 35px;
        margin-bottom: 15px;
        color: #000000;
    }

    .week-box {
        width: 345px;
        background: var(--bg-color-2);
        border-radius: 6px 6px 6px 6px;
        margin: 0 auto;
        color: var(--text-color-1);
    }

    .week {
        padding-left: 20px;
        font-size: 15px;
        /*border-bottom: 1px solid #000000;*/
        line-height: 51px;
        position: relative;
    }

    .to-icon {
        width: 16px;
        position: absolute;
        top: 20px;
        right: 12px;
    }

    .no-tag {
        font-size: 12px;
        text-align: center;
        margin: 30px auto;
        color: var(--text-color-2);
    }
</style>




// WEBPACK FOOTER //
// src/views/report/06yearHistory.vue